import { onDocumentReady } from "@story/story_assets";
import { Carousel } from "@story/story_assets/carousel";

import "@story/story_assets/slide";
import "@story/story_assets/modal/modal_gallery";
import "@story/story_assets/ajax_form";
import "@story/story_assets/turnstile";

onDocumentReady(function () {
	for (const element of document.querySelectorAll(".carousel")) {
		new Carousel(element);
	}
});
